import React from 'react'

interface SliderDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const SliderDT: React.FC<SliderDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M18.333 5.41797H13.333" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.00033 5.41797H1.66699" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.33366 8.33333C9.94449 8.33333 11.2503 7.0275 11.2503 5.41667C11.2503 3.80584 9.94449 2.5 8.33366 2.5C6.72283 2.5 5.41699 3.80584 5.41699 5.41667C5.41699 7.0275 6.72283 8.33333 8.33366 8.33333Z" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3333 14.582H15" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66699 14.582H1.66699" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.6667 17.5013C13.2775 17.5013 14.5833 16.1955 14.5833 14.5846C14.5833 12.9738 13.2775 11.668 11.6667 11.668C10.0558 11.668 8.75 12.9738 8.75 14.5846C8.75 16.1955 10.0558 17.5013 11.6667 17.5013Z" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default SliderDT
